<template>
  <div>
    <apexchart width="100%" height="170px" type="bar" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: ["identificados", "naoidentificados", "compraram"],
  data: _ => {
    return {
      options: {
        chart: {
          id: "visualizacoes-compras"
        },
        xaxis: {
        categories: ["Identificados", "Não identificados", "Compras"]
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true
          }
        },
        dataLabels: {
          enabled: true
        },
        theme: {
          monochrome: {
            enabled: true,
            color: "#db8c02",
            shadeTo: "light",
            shadeIntensity: 0.5
          }
        }
      },
      series: []
    };
  },
  mounted() {
    this.series = [
      {
        name: "",
        data: [this.identificados, this.naoidentificados, this.compraram]
      }
    ];
  }
};
</script>
